import { API_BASE_URL } from './api';

const API_URL = `${API_BASE_URL}/pages`;
class ApiError extends Error {
  page_status?: number;

  constructor(message: string, page_status?: number) {
    super(message);
    this.name = 'ApiError';
    this.page_status = page_status;
  }
}

// Helper to handle fetch responses
async function handleResponse(response: Response) {
  const contentType = response.headers.get('content-type');
  const data = contentType && contentType.includes('application/json')
    ? await response.json()
    : await response.text();

  if (!response.ok) {
    throw new ApiError(
      (data && (data.message || data.error)) || 'Request failed',
      response.status
    );
  }

  return data;
}

// -------------------- GET all Vouchers --------------------
export const getPages = async () => {
  try {
    console.log(`🔍 Fetching page from: ${API_BASE_URL}/pages`);
    const response = await fetch(`${API_BASE_URL}/pages`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await handleResponse(response);
    console.log('✅ Pages API response:', data);
    return data;
  } catch (error: any) {
    console.error('❌ Pages API error:', error);
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while fetching pages');
  }
};

// -------------------- GET single Voucher --------------------
export const getPageById = async (id: string) => {
  try {
    const response = await fetch(`${API_BASE_URL}/pages/${id}`);
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while fetching page ${id}`);
  }
};

// -------------------- CREATE FAQ --------------------
export const createPage = async (pageData: {
  page_title: string;
  page_description: string;
  page_slug: string;
  page_status: 'Active' | 'Inactive';
}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/pages`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(pageData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error('Network error while creating page');
  }
};

// -------------------- UPDATE FAQ --------------------
export const updatePage = async (
  page_id: number,
  pageData: {
    page_title: string;
    page_description: string;
    page_slug: string;
    page_status: 'Active' | 'Inactive';
  }
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/pages/${page_id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(pageData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while updating page ${page_id}`);
  }
};

// -------------------- DELETE PAGE --------------------
export const deletePage = async (page_id: number,
  pageData: {
    page_status:'Delete';
  }
) => {
  try {
    const response = await fetch(`${API_BASE_URL}/pages/delete/${page_id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(pageData),
    });
    return await handleResponse(response);
  } catch (error: any) {
    if (error instanceof ApiError) throw error;
    throw new Error(`Network error while deleting page ${page_id}`);
  }
};
